module.exports = __webpack_public_path__ + "img/event.4399945a.png";